const userRole = {
  GET_ROLE: 'GET_ROLE',
  GET_ROLES: 'GET_ROLES'
}

export { userRole }
